<p-panel>

	<ng-template pTemplate="header">
		<span class="font-bold text-lg">
			{{ 'users.access_tab_header' | translate }}
		</span>
	</ng-template>

	<div>
		<form class="p-fluid formgrid grid">

			<div class="field col-fixed flex flex-row align-items-center">
				<p-checkbox
					class="mt-3"
					name="utb_gestion_abonnement"
					inputId="utb_gestion_abonnement"
					[(ngModel)]="currentUtiAbonne.utb_gestion_abonnement"
					(ngModelChange)="editUtilisateurAbonne(currentAbonne.abo_id, currentUtiAbonne)"
					[disabled]="!canEditGestionAbonnementForAbonne(currentAbonne)"
					[binary]="true"
					[label]="'abonnes.subscription_management_right_label' | translate"
				></p-checkbox>
			</div>
		</form>

		<p-divider class="col-12 mt-4" align="left">
			<b>{{ 'common.sites_label' | translate }}</b>
		</p-divider>

		<!-- Liste des sites liés -->
		<form #sitesForm="ngForm" *ngIf="!selfEditing || amIGestionnaireAbo">
			<div class="flex flex-row flex-wrap">

				<p-card class="col-12 lg:col-6 xxl:col-4" *ngFor="let site of currentAbonne.sites">

					<!-- Gestion de l'accès -->
					<div class="site-card-content" *ngIf="nacIdBySite[site.sit_id]; else noAccessToSite">
						<div class="flex flex-row align-items-center">
							<div class="text-lg mr-2">
								{{site.sit_libelle}}
							</div>

							<button
								type="button"
								pButton
								icon="pi pi-times-circle"
								class="p-button-rounded p-button-text p-button-danger"
								(click)="unlinkUtilisateurFromSite(site)"
							></button>
						</div>

						<form class="p-fluid formgrid grid mt-3" *ngIf="canEditAccessLevelOfSites">
							<div class="field col-12 xl:col-10 xxxl:col-8">
								<label>
									{{ 'abonnes.access_level_label' | translate }}
								</label>

								<niveau-access-selector
									name="nac_id"
									[(ngModel)]="nacIdBySite[site.sit_id]"
									(ngModelChange)="editUtilisateurSite(currentAbonne.abo_id, site.sit_id, nacIdBySite[site.sit_id])"
									[placeholder]="'abonnes.access_level_label' | translate"
								>
								</niveau-access-selector>
							</div>
						</form>
					</div>

					<!-- Aucun accès donné -->
					<ng-template #noAccessToSite>

						<div class="site-card-content">
							<div class="flex flex-row mb-2">
								<div class="text-lg mr-2">
									{{site.sit_libelle}}
								</div>

								<div class="font-bold">
									{{ 'sites.no_access' | translate }}
								</div>
							</div>

							<button
								type="button"
								pButton
								icon="pi pi-link"
								(click)="linkUtilisateurToSite(site)"
								[label]="'sites.add_to_site_button' | translate"
							></button>
						</div>
					</ng-template>
				</p-card>
			</div>
		</form>
	</div>

</p-panel>